import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "text-format-64", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 51 51", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeWidth: 2.5, transform: "translate(6 13.5)" },
        React.createElement("path", { strokeLinecap: "round", d: "M37.5 24V6" }),
        React.createElement("ellipse", { cx: 30, cy: 15, rx: 7.75, ry: 9.25 }),
        React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M0 24 9 0l9 24" }),
        React.createElement("path", { d: "M3.75 15H15" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
